import axios from 'axios'

const franjas = {

    get_franjas: () => axios(`z-franjas/franjas`),
    update_franja: (params) => axios.put(`z-franjas/${params.id}/franjas`,params),
}
export default franjas
